export const performLogout = async ({
  refreshToken,
  terminate,
  revoke,
  warn
}) => {
  terminate()

  try {
    if (refreshToken) await revoke(refreshToken)
  } catch (error) {
    warn(error)
  }
}



// WEBPACK FOOTER //
// ./src/auth/logout.js